package com.essntl.features.crm.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.crm.ui.components.CRMHeader
import com.essntl.features.crm.ui.components.OrganizationListColumn
import com.essntl.uikit.components.utils.spacing

@Composable
fun CRMScreen(
    state: CRMState,
    onEvent: (CRMEvent) -> Unit,
    onNavigation: (CRMNavigation) -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxSize(),
    ) {
        CRMHeader(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
        )

        Spacer(modifier = Modifier.height(1.spacing))

        OrganizationListColumn(
            state = state,
            onNavigation = onNavigation,
            modifier = Modifier.weight(1f),
        )
    }
}